var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333252 7.01006C0.333252 3.49812 3.13992 0.333374 7.01325 0.333374C10.7999 0.333374 13.6666 3.43803 13.6666 6.99003C13.6666 11.1095 10.3066 13.6667 6.99992 13.6667C5.90658 13.6667 4.69325 13.3729 3.71992 12.7987C3.37992 12.5918 3.09325 12.4382 2.72659 12.5584L1.37992 12.959C1.03992 13.0658 0.733252 12.7987 0.833252 12.4382L1.27992 10.9426C1.35325 10.7356 1.33992 10.5153 1.23325 10.3417C0.659919 9.2868 0.333252 8.13174 0.333252 7.01006ZM6.13326 7.01006C6.13326 7.4841 6.51326 7.86467 6.98659 7.87135C7.45992 7.87135 7.83992 7.4841 7.83992 7.01673C7.83992 6.54269 7.45992 6.16212 6.98659 6.16212C6.51992 6.15544 6.13326 6.54269 6.13326 7.01006ZM9.20659 7.01672C9.20659 7.48409 9.58659 7.87134 10.0599 7.87134C10.5333 7.87134 10.9133 7.48409 10.9133 7.01672C10.9133 6.54268 10.5333 6.16211 10.0599 6.16211C9.58659 6.16211 9.20659 6.54268 9.20659 7.01672ZM3.91325 7.87135C3.44658 7.87135 3.05992 7.4841 3.05992 7.01673C3.05992 6.54269 3.43992 6.16212 3.91325 6.16212C4.38658 6.16212 4.76658 6.54269 4.76658 7.01673C4.76658 7.4841 4.38658 7.86467 3.91325 7.87135Z",
    fill: "#081D3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.fe53e4dc63a6760e3551240894c8da73.svg";
export { ForwardRef as ReactComponent };